export const SUB_MODULE_NAME = 'product-page/rfps';

// Actions
export const RECEIVE = `${SUB_MODULE_NAME}/receive`;
export const CLEAR = `${SUB_MODULE_NAME}/clear`;
